import { CardListItem } from "./card-list-item.content";
import type { ActivityCardProps } from "./types";
import { ActivityCardAvatar, ActivityCardContent } from "./activity-card-shared";

export const ActivityCard = ({ entry, onAction, trailing, footer }: ActivityCardProps) => (
  <CardListItem
    avatar={<ActivityCardAvatar entry={entry} />}
    content={<ActivityCardContent entry={entry} />}
    trailing={trailing}
    footer={footer}
    onAction={onAction}
  />
);
